export default __webpack_public_path__ + "static/media/affectationvillageActual.44999826.png";